import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const parallaxFooter = () => {

	document.fonts.ready.then(() => {
		const footer = document.querySelector('.footer')
		const inner = document.querySelector('.footer__bottom')

		if (window.innerWidth <= 650) return

		gsap.fromTo(
			inner,
			{
				yPercent: -250,
				scale: 1
			},
			{
				scrollTrigger: {
					trigger: footer,
					start: 'top bottom',
					end: 'bottom bottom',
					scrub: true
				},
				yPercent: 0,
				scale: 1
			}
		)
	})
}

export default () => {}
